import { useEffect, useState } from 'react';
import { dispatchTableFetchDataEvent, useTableOnSelectionEventEffect } from '../tables/tableEvents';

export function useReactTableActionBar<T>(identifier: string) {
  const [isActionable, setIsActionable] = useState<boolean>(false);
  const [showFloatingHeader, setShowFloatingHeader] = useState<boolean>(false);
  const [selection, setSelection] = useState<T[]>([]);

  useTableOnSelectionEventEffect(identifier, handleSelectionChange);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  function handleSelectionChange(event: CustomEvent<typeof selection>) {
    setSelection(event.detail);
  }

  function handleScroll() {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 275 && !showFloatingHeader) {
      setShowFloatingHeader(true);
    } else if (scrollPosition <= 275) {
      setShowFloatingHeader(false);
    }
  }

  useEffect(() => {
    setIsActionable(selection.length > 0);
  }, [selection]);

  const fetchData = (resetPageNumber = false) => {
    dispatchTableFetchDataEvent(identifier, resetPageNumber);
  };

  return {
    fetchData,
    isActionable,
    selection,
    setIsActionable,
    setSelection,
    showFloatingHeader,
  };
}

export default useReactTableActionBar;
